<template>
  <v-app>
    <Navbar v-if="token" />

    <v-main 
      min-height="80%"
      light>
      <router-view />
    </v-main>

    <div v-if="wame"
      class="d-flex align-center"
      style="position: fixed; bottom: 10px; right: 10px;">  
      <v-btn
        elevation="0"
        dark
        class="text-capitalize pl-0 pr-3 ma-4 mr-0"
        color="#0f9508"
        style="border-radius: 4px 0px 0px 4px; border-right: 1px solid #2baf24;"
        href="https://api.whatsapp.com/send/?phone=62811147187&text&app_absent=0"
        target="_blank">
        <v-avatar tile size="50"
          style="position: relative; left: -10px;">
          <v-img 
            contain
            alt="property"
            :src="require('@/assets/image/icon-wa.png')">
          </v-img>
        </v-avatar>
        
        Hubungi Kami
      </v-btn>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
           <v-btn
            v-bind="attrs"
            v-on="on"
            elevation="0"
            dark
            class="text-capitalize px-3 ma-4 ml-0"
            color="#0f9508"
            min-width="30"
            style="border-radius: 0px 4px 4px 0px;"
            @click="wame = false">
            <v-icon size="20">mdi-eye-off-outline</v-icon>
          </v-btn>
        </template>

        <span>Hide</span>
      </v-tooltip>
    </div>
  </v-app>
</template>

<script>
  import { get, post, put, destroy } from "./service/Axios";
  const Navbar = () => import(/* webpackPrefetch: true */ '@/components/Navbar.vue');
  export default {
    data () {
      return {
        wame: true
      }
    },
    components: {
      Navbar
    },
    computed: {
      token () {
        return this.$store.state.token
      }
    },
    watch: { 
      '$route' (to, from) {

      } 
    },
    methods: {

    },
    created() {
      if (process.browser) {
        if ('Notification' in window && 'serviceWorker' in navigator) {
          
        }
      }
    }
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#content {
  padding: 0px;
}
</style>